/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OptionalMapInput
 */
export interface OptionalMapInput {
    /**
     * 
     * @type {boolean}
     * @memberof OptionalMapInput
     */
    defined?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof OptionalMapInput
     */
    map?: { [key: string]: string; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof OptionalMapInput
     */
    set?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof OptionalMapInput
     */
    value?: { [key: string]: string; } | null;
}

/**
 * Check if a given object implements the OptionalMapInput interface.
 */
export function instanceOfOptionalMapInput(value: object): value is OptionalMapInput {
    return true;
}

export function OptionalMapInputFromJSON(json: any): OptionalMapInput {
    return OptionalMapInputFromJSONTyped(json, false);
}

export function OptionalMapInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptionalMapInput {
    if (json == null) {
        return json;
    }
    return {
        
        'defined': json['defined'] == null ? undefined : json['defined'],
        'map': json['map'] == null ? undefined : json['map'],
        'set': json['set'] == null ? undefined : json['set'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function OptionalMapInputToJSON(json: any): OptionalMapInput {
    return OptionalMapInputToJSONTyped(json, false);
}

export function OptionalMapInputToJSONTyped(value?: OptionalMapInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'defined': value['defined'],
        'map': value['map'],
        'set': value['set'],
        'value': value['value'],
    };
}

